export default "__VITE_ASSET__BjLaC_Ag__$_?url__"